import { useEffect } from 'react'

import { useParams } from 'react-router-dom'

import { isDriverTrackingAllowed } from 'components/booking-tracking/helpers'
import {
  DriverLocation,
  useGetBookingByTrackingHashQuery,
  useGetDriversLocationsByTrackingHashQuery,
} from 'generated/graphql'

export const useBookingTrackingData = () => {
  const { trackingHash } = useParams<{ trackingHash: string }>()

  const { data: bookingData, loading: bookingDataLoading } = useGetBookingByTrackingHashQuery({
    variables: {
      trackingHash: trackingHash,
    },
    skip: !trackingHash,
  })

  const {
    data: ourDriversLocationsData,
    startPolling: startPollingOurDrivers,
    stopPolling: stopPollingOurDrivers,
  } = useGetDriversLocationsByTrackingHashQuery({
    fetchPolicy: 'network-only',
    variables: { trackingHash: trackingHash },
    skip:
      !bookingData?.bookingByTrackingHash?.booking?.isDomesticDedicated ||
      !isDriverTrackingAllowed(bookingData?.bookingByTrackingHash?.booking?.status),
  })

  const driversLocations =
    ourDriversLocationsData?.driversLocationsByTrackingHash &&
    ourDriversLocationsData?.driversLocationsByTrackingHash?.filter((x) => x)?.length > 0
      ? (ourDriversLocationsData?.driversLocationsByTrackingHash as Array<DriverLocation>)
      : []

  const isExpired = bookingData?.bookingByTrackingHash?.isExpired
  const booking = bookingData?.bookingByTrackingHash?.booking
  const expiresOn = bookingData?.bookingByTrackingHash?.expiresOn
  const referenceAddressId = bookingData?.bookingByTrackingHash?.referenceAddressId
  const isDomesticDedicated = booking?.isDomesticDedicated ?? false

  useEffect(() => {
    if (
      trackingHash &&
      !isExpired &&
      isDomesticDedicated &&
      isDriverTrackingAllowed(booking?.status)
    ) {
      startPollingOurDrivers(5000)
    }
    return () => {
      stopPollingOurDrivers()
    }
  }, [
    booking?.status,
    isDomesticDedicated,
    isExpired,
    startPollingOurDrivers,
    stopPollingOurDrivers,
    trackingHash,
  ])

  return {
    trackingHash,
    bookingData: booking,
    bookingDataLoading,
    driversLocations,
    isDomesticDedicated,
    isExpired,
    expiresOn,
    referenceAddressId,
  }
}
